import React from 'react'
import { OrderModalDescriptionText, OrderModalDescriptionTitle, OrderModalDescriptionWrapper } from './index.styled'

const OrderModalDescription = React.memo(({ title, text, children }) => (
	<OrderModalDescriptionWrapper>
		<OrderModalDescriptionTitle>{title}</OrderModalDescriptionTitle>
		<OrderModalDescriptionText>{text}</OrderModalDescriptionText>
		{children}
	</OrderModalDescriptionWrapper>
))

OrderModalDescription.displayName = 'OrderModalDescription'
export default OrderModalDescription
